import React, { Component, PropTypes } from 'react';
import {
	Dropdown,
	Spinner,
	Icon,
	Tooltip,
	Alert,
} from './';

// Import the CSS
import '../../scss/containers/feeds/_link-pane.scss';

export default class CorporationFound extends Component {

	handleClickCreateNew (e) {
		e.preventDefault();

		this.props.onCreateNew();
	}

	handleClickFindMatch (e) {
		e.preventDefault();

		this.props.onFindMatch();
	}

	handleClickLink (e, link) {
		e.preventDefault();

		this.props.onLink(link);
	}

	render() {
		return (
			<div className="corporation-linking-pane-list-item">
				<div className="corporation-linking-pane-row">
					<div className="corporation-details">
						<div>{ this.props.corporation.name }</div>
						<div>{ this.props.corporation.number }</div>
					</div>

					{/* Render create button state */}
					<Choose>
						<When condition={ this.props.status === 'created' }>
							<div className="corporation-action-success">
								<Icon type="check-circle" />
								Created
							</div>
						</When>
						<When condition={ this.props.status === 'creating' }>
							<Spinner style="inline" />
							<a href="#" className="disabled corporation-action-btn">
								<span>Creating...</span>
							</a>
						</When>
						<When condition={ !this.props.status }>
							<a href="#" className="corporation-action-btn" onClick={ e => this.handleClickCreateNew(e) }>
								Create New
							</a>
						</When>
					</Choose>

					{/* Render find match button or update button state */}
					<Choose>
						<When condition={ this.props.status === 'updating' }>
							<Spinner style="inline" />
							<a href="#" className="disabled corporation-action-btn">
								<span>Updating</span>
							</a>
						</When>
						<When condition={ this.props.status === 'updated' }>
							<div className="corporation-action-success">
								<Icon type="check-circle" />
								Updated
							</div>
						</When>
						<When condition={ this.props.isFetchingLinks }>
							<Spinner style="inline" />
							<a href="#" className="disabled corporation-action-btn">
								<span>Find Match</span>
							</a>
						</When>
						<When condition={ !this.props.status }>
							<a href="#" className="corporation-action-btn" onClick={ e => this.handleClickFindMatch(e) }>
								Find Match
							</a>
						</When>
					</Choose>

				</div>

				{/* Display potential creation error or warning message */}
				<If condition={ this.props.createError }>
					<Alert type="tooltip" style="error" dismissTimer={5000}>
						{ this.props.createError.message }
					</Alert>
				</If>
				<If condition={ this.props.warningMessage }>
					<Alert type="tooltip" style="warning" dismissTimer={5000}>
						<span key={ this.props.warningMessage.key }>
							{ this.props.warningMessage.text }
						</span>
					</Alert>
				</If>

				<If condition={ this.props.selected }>

					{/* Render link/unlink icon or loading spinner */}
					<div className="corporation-linking-pane-row selected">

						<div className="corporation-details corporation-link-toggle">
							<Choose>

								<When condition={ !this.props.status || this.props.status === 'unlinked' }>
									<Tooltip style="icon" text="Click to link this corporation to this feed." position="bottom">
										<Icon type="unlink" onClick={ e => this.handleClickLink(e, true) } />
									</Tooltip>
								</When>

								<When condition={ this.props.status === 'linking' || this.props.status === 'unlinking' }>
									<Spinner style="inline" />
								</When>

								<When condition={ this.props.status === 'linked' }>
									<Tooltip style="icon" text="Click to unlink this corporation from this feed." position="bottom">
										<Icon type="link" onClick={ e => this.handleClickLink(e, false) } />
									</Tooltip>
								</When>

							</Choose>
						</div>

						<div className="corporation-details">
							<div>{ this.props.selected.name }</div>
							<div>{ this.props.selected.number }</div>
						</div>

					</div>

					{/* Show link error message */}
					<If condition={ this.props.linkError }>
						<Alert dismissTimer={5000} style="error">
							{ this.props.linkError.message }
						</Alert>
					</If>
				</If>

				<If condition={ this.props.showAutoComplete && !this.props.status }>
					<div className="corporation-linking-pane-row">
						<Dropdown
							wrap
							options={ this.props.options }
							error={ this.props.searchError }
							selected={ this.props.selected }
							placeholder="Search by name or number..."
							name="corporporation-linking-auto-complete"
							isFetchingOptions={ this.props.isSearching }
							onChange={ option => this.props.onChange(option) }
							autoComplete={ value => this.props.onInput(value) }
							emptyLabel={ <span className="placeholder"> Select a matching corporation from another feed </span> }
						/>
					</div>
				</If>

			</div>
		);
	}

}

CorporationFound.propTypes = {

	corporation: PropTypes.object.isRequired,
	linkStatus: PropTypes.string,
	isFetchingLinks: PropTypes.bool,
	isSearching: PropTypes.bool,
	isDisabled: PropTypes.bool,
	status: PropTypes.oneOf([
		'',
		'creating',
		'created',
		'updating',
		'updated',
		'linking',
		'linked',
		'unlinking',
		'unlinked',
		'hidden',
	]),

	onCreateNew: PropTypes.func.isRequired,
	onFindMatch: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onInput: PropTypes.func.isRequired,
	onLink: PropTypes.func.isRequired,

	selected: PropTypes.object,
	showAutoComplete: PropTypes.bool,
	options: PropTypes.array,

	createError: PropTypes.object,
	searchError: PropTypes.object,
	linkError: PropTypes.object,
	warningMessage: PropTypes.shape({
		key: PropTypes.string,
		text: PropTypes.string,
	}),

};



// WEBPACK FOOTER //
// ./src/assets/js/components/CorporationFound.js